<app-table
  [tableColumns]="
    [
      {
        key: 'createdAt',
        label: 'models.branch.createdAt.label' | translate,
        width: '180px',
        cellTemplate: dateCellTemplate,
        sort: true,
      },
      {
        key: 'createdBy',
        label: 'models.branch.createdBy.label' | translate,
        width: '250px',
        cellTemplate: userCellTemplate,
        sort: true,
      },
      {
        key: 'addressCount',
        label: 'models.branch.addressCount.abbreviation' | translate,
        width: '80px',
        align: 'right',
        sort: true,
      },
      {
        key: 'source',
        label: 'models.branch.source.label' | translate,
        width: '120px',
        cellTemplate: markedCellTemplate,
        sort: true,
      },
      {
        key: 'reason',
        label: 'models.branch.reason.label' | translate,
        width: '90px',
        cellTemplate: markedCellTemplate,
        sort: true,
      },
      {
        key: 'fundingCode',
        label: 'models.branch.fundingCode.label' | translate,
        width: '180px',
        cellTemplate: markedCellTemplate,
        sort: true,
      },
      {
        key: 'mevId',
        label: 'models.branch.mevId.label' | translate,
        width: '190px',
        cellTemplate: markedCellTemplate,
        align: 'right',
        sort: true,
      },
      {
        key: 'note',
        label: 'models.branch.note.label' | translate,
        width: '350px',
        cellTemplate: markedCellTemplate,
        sort: true,
      },
      {
        key: 'state',
        label: 'models.branch.state.label' | translate,
        width: '120px',
        cellTemplate: statusCellTemplate,
        fixRight: true,
        sort: true,
      },
      {
        key: 'validationSummary',
        label: 'pages.clearings.table.validationSummary.label' | translate,
        width: '210px',
        cellTemplate: validationSummaryCellTemplate,
        fixRight: true,
        sort: false,
      },
    ] | mergeColumns: tableColumns : removeColumns
  "
  [tableData]="tableData"
  [total]="total"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [isLoading]="isLoading"
  [defaultSorting]="this.activeSorting"
  [customNoResultText]="customNoResultText"
  (changeHandler)="changeTableHandler($event)"
/>

<ng-template
  #validationSummaryCellTemplate
  let-currentRow="currentRow"
  [typedTemplate]="typeToken"
>
  <div data-test-id="validationSummary" class="mt-2 flex flex-wrap gap-2">
    @if (currentRow.processState === 'ADDRESS_VALIDATION_COMPLETED') {
      @if (currentRow.unverifiedAddresses > 0) {
        <app-number size="small" type="info">
          {{
            'components.branchDetailBase.filter.isUnverifiedAddress' | translate
          }}
          : {{ currentRow.unverifiedAddresses }}
        </app-number>
      }
      @if (currentRow.conflictAddresses > 0) {
        <app-number size="small" type="error">
          {{
            'components.branchDetailBase.filter.isConflictAddress' | translate
          }}
          : {{ currentRow.conflictAddresses }}
        </app-number>
      }
      @if (currentRow.newAddresses > 0) {
        <app-number size="small" type="notice">
          {{ 'components.branchDetailBase.filter.isNewAddress' | translate }}:
          {{ currentRow.newAddresses }}
        </app-number>
      }
      @if (currentRow.duplicateWithChanges > 0) {
        <app-number size="small" type="warning">
          {{
            'components.branchDetailBase.filter.isDuplicateWithChange'
              | translate
          }}
          : {{ currentRow.duplicateWithChanges }}
        </app-number>
      }
      @if (currentRow.duplicateInCsv > 0) {
        <app-number size="small" type="warning">
          {{
            'components.branchDetailBase.filter.isDuplicateInCsv' | translate
          }}
          : {{ currentRow.duplicateInCsv }}
        </app-number>
      }
    } @else {
      @if (currentRow.processState === 'UPLOAD_FAILED') {
        <app-process-error
          data-test-id="processError"
          size="small"
          [processFailureReason]="currentRow.processFailureReason"
        />
      } @else {
        <app-process-bar
          data-test-id="processBar"
          size="small"
          [processState]="currentRow.processState"
        />
      }
    }
  </div>
</ng-template>

<ng-template #dateCellTemplate let-item="item">
  {{ item | date: 'dd.MM.yyyy - HH:mm:ss' }}
</ng-template>

<ng-template #userCellTemplate let-item="item">
  <app-user [userMail]="item" [highlight]="sword" />
</ng-template>

<ng-template #statusCellTemplate let-item="item">
  <app-branch-status [status]="item" />
</ng-template>

<ng-template #markedCellTemplate let-item="item">
  <div [innerHTML]="item | highLightText: sword"></div>
</ng-template>
